import React from 'react';
import './styles.css';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const BupSpinner = ({ size }) => {
  return (
    <div className="loading-spinner-container">
      <Spin
        indicator={
          <LoadingOutlined
            style={{
              fontSize: size === 'large' ? 54 : size === 'medium' ? 40 : 24,
            }}
            spin
          />
        }
      />
    </div>
  );
};

export default BupSpinner;
